exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.category-list h2 a[data-v-14dccf72]{\n    color: #546b81;\n    text-decoration: none;\n}\n.category-list h2 a[data-v-14dccf72]:hover{\n    text-decoration: underline;\n}\n.category-list h2 small[data-v-14dccf72]{\n    color: #bbbbbb;\n    font-size: 1em;\n    margin-left: 0.2rem;\n}\n", ""]);

// exports
